import * as Yup from 'yup'

export const newAssignmentCellphoneSchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañía es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  // TipoData?: string // "CAP",
  TipoEdificacionId: Yup.string().required('Edificación es requerido')
})

export const newAssignmentCleaningSchedulesSchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañía es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  // TipoData?: string // "CAP",
  TipoEdificacionId: Yup.string().required('Edificación es requerido')
})

export const censusHistorySchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañía es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  CampamentoId: Yup.string().required('Campamento es requerido'),
  ModuloId : Yup.string().required('Módulo es requerido'),
  FechCenso: Yup.string().required('Fecha de censo es requerido')
})